import template from './access-type.jade';
import accessTypeItems from '../../../enums/access-type';

export default angular
    .module('cian.addForm.aboutObjectAccessType', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfAboutObjectAccessType', () => ({
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: function() {
            this.items = accessTypeItems;
        },
        controllerAs: 'accessType',
        template,
    }))
    .name;
